import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightFromLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-arrow-right-from-line-icon lucide-arrow-right-from-line", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 5v14" }), /* @__PURE__ */ React.createElement("path", { d: "M21 12H7" }), /* @__PURE__ */ React.createElement("path", { d: "m15 18 6-6-6-6" }));
const ForwardRef = forwardRef(SvgArrowRightFromLine);
export default ForwardRef;
